import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-68d6ccb4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  })], -1);
});

var _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: "back-to-top",
    class: _normalizeClass($setup.buttonClass),
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.scrollToTop && $setup.scrollToTop.apply($setup, arguments);
    })
  }, _hoisted_2, 2);
}